import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormLabel } from '@material-ui/core';
import { CheckIcon } from '../Icons';

const StyledCheckbox = ({ value, label, classes, checked, icon, onChange }) => {
  const Icon = icon;
  return (
    <>
      <FormLabel className={classes.label}>
        {icon && (
          <div className={classes.icon}>
            <Icon />
          </div>
        )}
        {label}
        <Checkbox
          className={classes.checkbox}
          value={value}
          icon={<span />}
          checkedIcon={<CheckIcon className={classes.checkedIcon} />}
          onChange={onChange}
          checked={checked}
        />
      </FormLabel>
    </>
  );
};

StyledCheckbox.propTypes = {
  value: PropTypes.string,
  label: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.string),
  checked: PropTypes.bool,
};

StyledCheckbox.defaultProps = {
  value: '',
  label: null,
  classes: {},
  checked: false,
};

export default StyledCheckbox;
